import React, {useEffect, useState} from "react";
import IbatApi from "../../utils/IbatApi";
import BillIcon from "../../images/new-devis.png";
import {useSnackbar} from "notistack";
import DocumentLoader from "../util/DocumentLoader";

export default function EditBillForm({id, content, bills}){
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [bill,setBill] =useState(content ?? "");
    const [billList, setBillList] = useState(bills ?? false);

    let api = new IbatApi();


    useEffect(()=>{
        !billList && api.getIntervention(id).then(r=>{
            setBillList(r.bills)
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[content])



    return(<div className={"editIntervention flex-column primary-section"}>
            <div className={"img-container"}>
                <img alt={""} src={BillIcon}/>
            </div>

            {
                billList && billList.length > 0 &&
                <div className={"secondary-section"}>
                    <p>Factures</p>
                    {billList?.map(b => <div className={"flex-row"}>
                        {b.odooPdfId && <DocumentLoader name={b.odooId} type={"bill"}/>}
                        {b.odooRef}
                    </div>)}
                </div>
            }
        </div>

    )
}